/** Источник прихода клиента */
export const LEAD_SOURCES = [
  "Instagram",
  "ВКонтакте",
  "Сарафанное радио",
  "Реклама",
  "Яндекс / Google",
  "2GIS",
  "Сайт клуба",
  "Пробное занятие",
  "Другое",
];

/** Предустановленные теги для сегментации */
export const CLIENT_TAG_PRESETS = [
  { id: "newbie", label: "Новичок" },
  { id: "athlete", label: "Спортсмен" },
  { id: "adult", label: "Взрослый" },
  { id: "kids", label: "Дети" },
  { id: "debtor", label: "Должник" },
  { id: "influencer", label: "Лидер мнений" },
  { id: "trial", label: "Пробное" },
  { id: "vip", label: "VIP" },
];

export function tagPresetLabel(id) {
  return CLIENT_TAG_PRESETS.find((t) => t.id === id)?.label || id;
}
